import type { Mark } from '../document-types';
import type { MarkHandler } from './types';

export class LinkMark implements MarkHandler {
  readonly type = 'link';

  apply(text: string, mark: Mark): string {
    const href = mark.attrs?.['href'] ?? '';
    const title = mark.attrs?.['title'];
    return title ? `[${text}](${href} "${title}")` : `[${text}](${href})`;
  }
}
